import React from 'react';
import cn from 'classnames';

import GameLogo from '../GameLogo';
import CompetitorLogo from '../CompetitorLogo';
import './topBannerCompetitorInfo.scss';

interface Props {
    sportId: string;
    logo: string;
    name: string;
    isHome: boolean;
    withSportLogo?: boolean;
}

const TopBannerCompetitorInfo: React.FC<Props> = ({
    sportId,
    logo,
    isHome,
    name,
    withSportLogo,
}) => {
    return (
        <div
            styleName="container"
            className={cn('__app-TopBannerCompetitorInfo-container', {
                '__app-TopBannerCompetitorInfo-container-is-home': isHome,
            })}
        >
            {withSportLogo && <GameLogo gameId={sportId} />}

            <div
                styleName="competitor"
                className="__app-TopBannerCompetitorInfo-competitor"
            >
                <CompetitorLogo logoUrl={logo} sportId={sportId} />
                <div
                    styleName="wrapper"
                    className="__app-TopBannerCompetitorInfo-wrapper"
                >
                    <div
                        styleName="name"
                        className="__app-TopBannerCompetitorInfo-name"
                    >
                        {name}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(TopBannerCompetitorInfo);
